/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object,
} from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useUIDSeed } from 'react-uid';
import Data from './ViewData';

const styles = (theme)  => ({
    container: {
        width: '100%',
        margin: '15px auto',
        maxWidth: '1020px',
        '& h1': {
            textAlign: 'center',
            fontSize: '24px',
            color: theme.palette.sympathytitlecolor,
            fontWeight: 'normal',
            marginBottom: 0,
        },
    },
    innerContainer: {
        '& ul': {
            fontSize: '14px',
            '& a': {
                color: theme.palette.grey3,
            },
        },
    },
    question: {
        fontSize: '14px',
        color: theme.palette.common.green,
        margin: '0px',
    },
    answer: {
        margin: '0px 0px 15px',
        fontSize: '14px',
        '& a': {
            color: theme.palette.grey3,
        },
    },
    description: {
        fontSize: '14px',
    },
});

const SympathyFrequentlyAskedQuestionsPage = ({ classes }) => {
    const {
        page_title, content, description_top, description_bottom,
    } = Data;
    const seed = useUIDSeed();
    return (
        <>
            <div className={classes.container}>
                <h1>{page_title}</h1>
                <p className={classes.description}>{description_top}</p>
                <div className={classes.innerContainer}>
                    {content.map((data)  => {
                        const { question, answer, answer_content } = data;
                        return (
                            <div key={seed(data)}>
                                <h2 className={classes.question}>{question}</h2>
                                {answer_content
                                    ? (
                                        <ul> {answer_content.map((list) => {
                                            const { description } = list;
                                            return (<li key={seed(list)}> {ReactHtmlParser(description)} </li>);
                                        })}
                                        </ul>
                                    )
                                    : <p className={classes.answer}>{ReactHtmlParser(answer)}</p>}
                            </div>
                        );
                    })}
                    <p className={classes.description}>{description_bottom}</p>
                </div>
            </div>
        </>
    );
};

SympathyFrequentlyAskedQuestionsPage.propTypes = {
    classes: object.isRequired,
};
export default withStyles(styles)(SympathyFrequentlyAskedQuestionsPage);
